export enum Radius {
    Small = 22.5,
    Medium = 55,
    Large = 92,
}
